import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MainService } from 'src/app/services/main.service';
import { StoreService } from 'src/app/services/store.service';

@Component({
  selector: 'app-stores-attr-validation',
  templateUrl: './stores-attr-validation.component.html',
  styleUrls: ['./stores-attr-validation.component.scss']
})
export class StoresAttrValidationComponent implements OnInit {
  uploadWarnings : Array<any> = [];
  displayedColumns: string[] = ['sucursal', 'atributo', 'valor', 'mensaje'];
  dataSource!: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private main: MainService,
    private store : StoreService,
    private dialogRef: MatDialogRef<StoresAttrValidationComponent>,
    @Inject(MAT_DIALOG_DATA) public data : any,
  ) { 
    this.uploadWarnings = data;

  }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this.uploadWarnings);        
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getAttribute(row: any): any {
    return row.atributo ?? row.farmID;
  }

  getValue(row: any): any {
    return row.value ?? row.val;
  }

  getValidation(row: any): any {
    return row.validation ?? row.mensaje;
  }
}
